import React, { useState, useEffect } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Typography, Box, Grid } from "@mui/material/";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { BarChart } from "@mui/x-charts/BarChart";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../Components/PageTitle";
import { getTeachers } from "../redux/actions/admin/teachersAction";
import { getCourses } from "../redux/actions/admin/courseAction";
import { getBatch } from "../redux/actions/admin/batchAction";
import { getStudents } from "../redux/actions/admin/studentAction";
import { listContacts } from "../redux/actions/admin/contactAction";

const Dashboard = () => {
  const dispatch = useDispatch();

  const { teachers, loading } = useSelector((state) => state.teacher);
  const { courses, error } = useSelector((state) => state.courses);
  const { batches } = useSelector((state) => state.batches);
  const { students } = useSelector((state) => state.studentData);
  const { contacts } = useSelector((state) => state.contactList);

  const [allTeachers, setAllTeachers] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [allBatches, setAllBatches] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [allContacts, setAllContacts] = useState([]);

  useEffect(() => {
    dispatch(getTeachers());
  }, [dispatch]);

  useEffect(() => {
    setAllTeachers(teachers);
  }, [teachers]);

  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);

  useEffect(() => {
    setAllCourses(courses);
  }, [courses]);

  useEffect(() => {
    dispatch(getBatch());
  }, [dispatch]);

  useEffect(() => {
    setAllBatches(batches);
  }, [batches]);

  useEffect(() => {
    dispatch(getStudents());
  }, [dispatch]);

  useEffect(() => {
    setAllStudents(students);
  }, [students]);

  useEffect(() => {
    dispatch(listContacts());
  }, [dispatch]);

  useEffect(() => {
    setAllContacts(contacts);
  }, [contacts]);

  return (
    <>
      <PageTitle
        title="Admin Dashboard - Shree Mangalam School"
        description="Access the Admin Dashboard of Shree Mangalam School to manage student data, courses, exams, and digital resources for efficient academic administration."
        url="/dashboard"
        keywords="admin dashboard, Shree Manglam admin panel, manage students, school admin tools, educational dashboard, RIMC coaching management"
      />

      <Box>
        <Box sx={{ mt: 1, ml: 2, mr: 2 }}>
          <Grid container spacing={4}>
            {[
              {
                title: "Teachers",
                value: allTeachers?.length,
                // color: "rgb(0, 123, 255)",
                // color: "#2d42a8",
                color: "rgb(2, 178, 175)",
              },
              {
                title: "Courses",
                value: allCourses?.length,
                // color: "rgb(184, 193, 7)",
                color: "rgb(46, 150, 255)",
              },
              {
                title: "Batches",
                value: allBatches?.length,
                // color: "rgb(40, 167, 69)",
                color: "rgb(184, 0, 216)",
              },
              {
                title: "Students",
                value: allStudents?.length,
                color: "rgb(96, 0, 155)",
                // color: "rgb(184, 0, 69)",
              },

              {
                title: "Contacts",
                value: allContacts?.length,
                fontWeight: "bold",
                // color: "rgb(108, 117, 125)",
                color: "rgb(3, 0, 141)",
              },
            ].map((card, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                <Box variant="h5">
                  <Card
                    sx={{
                      transition: "0.3s !important",
                      "&:hover": { transform: "scale(1.05)" },
                      borderRadius: "15px",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                      padding: "15px",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      // backgroundColor: "#FFF",
                      backgroundColor: card.color,
                    }}
                  >
                    {" "}
                    <CardContent>
                      <Typography variant="h5" component="div" color="#fff">
                        {" "}
                        {card.title}
                      </Typography>
                      <Typography
                        variant="h4"
                        component="div"
                        color="#fff"
                        sx={{ fontWeight: "bold", pt: 1 }}
                      >
                        {card.value}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Typography
            variant="h5"
            className="courses_title"
            gutterBottom
            sx={{
              mt: 5,
              mb: 5,
              letterSpacing: "2px",
              lineHeight: 1.8,
              fontFamily: "Poppins, sans-serif",
              fontWeight: "bold",
              color: "#2C3E50",
            }}
          >
            Data Visualization
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Paper elevation={5} sx={{ p: 2 }}>
                <PieChart
                  series={[
                    {
                      data: [
                        {
                          id: 0,
                          value: allTeachers?.length,
                          label: "Teachers",
                        },
                        { id: 1, value: allCourses?.length, label: "Courses" },
                        { id: 2, value: allBatches?.length, label: "Batches" },
                        {
                          id: 3,
                          value: allStudents?.length,
                          label: "Students",
                        },
                        {
                          id: 4,
                          value: allContacts?.length,
                          label: "Contacts",
                        },
                      ],
                    },
                  ]}
                  height={250}
                />
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper elevation={5} sx={{ p: 2 }}>
                <BarChart
                  series={[
                    { data: [allTeachers?.length] },
                    { data: [allCourses?.length] },
                    { data: [allBatches?.length] },
                    { data: [allStudents?.length] },
                    { data: [allContacts?.length] },
                  ]}
                  height={250}
                  xAxis={[{ scaleType: "band", data: ["Data"] }]}
                  margin={{ top: 10, bottom: 40, left: 50, right: 10 }}
                />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
